import React from 'react';
import heroImage from '../../assets/images/hero.webp';
import heroImageMobile from '../../assets/images/hero1.webp';
import './HomeHero.css';

const HomeHero = () => {
  return (
    <section className='home-hero'>
      <div className='container'>
        <div className='hero-content'>
          <div className='hero-left '>
            <h1 className='hero-title'>
              Trusted <span className='highlight'>Financial Advisors</span> in Sydney for Expert Financial Planning
            </h1>

            <p className='hero-description'>
              We help individuals and businesses in Lewisham and across Sydney make smarter financial decisions. From strategic planning to wealth
              management, our experts are here to guide your financial journey.
            </p>

            <div className='hero-buttons'>
              <a className='btn btn-hero-primary' href='/contact'>
                Get a Free Quote
              </a>

              <a className='btn btn-hero-secondary' href='/accounting-services'>
                Explore Our Services
                <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M6 12L10 8L6 4' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
              </a>
            </div>

            <div className='hero-stats'>
              <div className='stat-card'>
                <div className='stat-number'>98%</div>
                <div className='stat-text'>Client Satisfaction</div>
              </div>
              <div className='stat-card'>
                <div className='stat-number'>12+</div>
                <div className='stat-text'>Years in Service</div>
              </div>
            </div>
          </div>

          <div className='hero-right'>
            <picture>
              <source media='(max-width: 768px)' srcSet={heroImageMobile} width='900' height='900' />
              <img
                src={heroImage}
                alt='Professional accountant in office'
                className='hero-image'
                width='1100'
                height='1256'
                fetchpriority='high'
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
